<template>
  <div class="update">
    <div class="update__wrapper" :class="{ 'not-subscribe': notSubscribe }">
      <div v-if="tags" class="update__tags">
        <Tag
          v-for="(tag, index) in tags.filter((item, index) => index < 3)"
          :key="index"
          :text="tag.name"
          :color="'red'"
          :link="tag.view_taxonomy_term"
          :uuid="tag.uuid"
          :tid="tag.tid"
        />
      </div>
      <div v-if="date" class="update__date">
        <Date :text="date" />
      </div>
      <div v-if="hasAccess" class="update__title">
        <nuxt-link v-if="link" :to="link" :target="newTab ? '_blank' : '_self'" v-html="title" />
        <p v-else>{{ title }}</p>
      </div>
      <div
        v-if="!hasAccess"
        class="update__title"
        style="color: #262a2e !important"
      >
        <p class="unauthorised">{{ noAccessShort }}</p>
      </div>
      <div class="update__relevant">
        <div class="update__relevant-number">
          {{ amountRelevant }}
        </div>
        <div class="update__relevant-info">
          {{ infoRelevant }}
        </div>
      </div>
      <Tooltip v-if="notSubscribe" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { noAccessShort } from "@/utils/constants";

export default {
  name: "Update",
  components: {
    Date: () => import("../elements/Date"),
    Tag: () => import("../elements/Tag"),
    Tooltip: () => import("../elements/Tooltip"),
  },
  props: {
    date: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: "",
    },
    amountRelevant: {
      type: [Number, String],
      default: null,
    },
    infoRelevant: {
      type: String,
      default: null,
    },
    tags: {
      type: [Array, String],
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notSubscribe: false,
      noAccessShort,
    };
  },
  computed: {
    ...mapState("Profile", ["userAccess"]),
  },
  mounted() {
    if (!this.productAccess || !this.productAccess.length) {
      this.notSubscribe = false;
    } else {
      for (let i = 0; i < this.productAccess.length; i++) {
        if (
          this.userAccess &&
          this.userAccess.includes(this.productAccess[i])
        ) {
          this.notSubscribe = false;
          if (this.productAccess[i]) break;
        } else {
          this.notSubscribe = true;
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.update {
  position: relative;
  padding-left: 4rem;

  &__wrapper {
    position: relative;
  }

  &:after {
    position: absolute;
    content: "";
    width: 1.6rem;
    height: 1.6rem;
    border: 2px solid $black;
    background: #8dc8e8;
    border-radius: 50%;
    left: 0;
    top: 2rem;
  }

  &:before {
    position: absolute;
    content: "";
    width: 2rem;
    height: 1px;
    border-bottom: 1px dashed $border;
    left: -2rem;
    top: 3rem;
  }

  &__title {
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2rem;
    margin-top: 0.4rem;

    a {
      color: $text_gray !important;
    }
  }

  &__relevant {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 600;

    &-number {
      color: $text;
      margin-right: 1rem;
    }

    &-info {
      color: $red !important;
    }
  }

  &__tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #b1b3b3;
    margin-bottom: 1.2rem;

    &-more {
      margin-left: 1rem;
      font-weight: 600;
    }
  }
}
</style>
